/**
 * @description: 原生客户端 API 接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */
export default {
	// OSS 鉴权
	OSS_AUTH_API: '/me/sts',
	// 获取会员套餐支付方式
	GET_MEMBERSHIP_PAYMENT_API: '/Payment/GetPaymentChannel',
	// 获取会员套餐支付参数
	GET_MEMBERSHIP_PAYMENT_PARAM_API: '/Payment/CreateUnifiedOrder',
	// 关注用户
	FOLLOW_USER_API: '/me/follow',
	// 取消关注用户
	CANCEL_FOLLOW_USER_API: '/Me/CancelFollow',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/client-api.js